import {
  ABOUT_CHECKMATE_URL,
  ALL_SERVICE_URL,
  CHECKMATE_PLUS_URL,
  KOREA_HOUSING_INFO_URL,
  MEMBERSHIP_URL,
  REVIEW_URL,
  WHY_CHECKMATE_URL,
} from 'shared/constants';

export const NavList = [
  {
    title: 'Room Search',
    to: '/listing',
  },

  {
    title: 'About Us',
    subMenu: [
      {
        title: 'About Checkmate',
        to: ABOUT_CHECKMATE_URL,
        target: '_blank',
      },
      {
        title: 'Why Checkmate',
        to: WHY_CHECKMATE_URL,
        target: '_blank',
      },
    ],
  },
  {
    title: 'How to Use',
    subMenu: [
      {
        title: 'Booking Guide',
        to: '/guide',
      },
      {
        title: 'Korean Housing Info',
        to: KOREA_HOUSING_INFO_URL,
        target: '_blank',
      },
      {
        title: 'All Services',
        to: ALL_SERVICE_URL,
        target: '_blank',
      },
    ],
  },

  {
    title: 'Blog',
    to: '/blog',
  },
  {
    title: 'Membership',
    to: MEMBERSHIP_URL,
    target: '_blank',
  },
  {
    title: 'Checkmate Plus',
    to: CHECKMATE_PLUS_URL,
    target: '_blank',
  },
  { title: 'Reviews', to: REVIEW_URL, target: '_blank' },
];
